type NumberStyle = 'decimal' | 'currency' | 'compact';

const formatters = new Map<string, Intl.NumberFormat>();
const MAX_FORMATTERS = 32;

/** Reuse locale setup across rows and renders; keep the cache bounded for variable precision/locale inputs. */
export function getNumberFormatter(
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  style: NumberStyle = 'decimal',
  locale = 'en-US',
): Intl.NumberFormat {
  const key = `${locale}:${style}:${minimumFractionDigits}:${maximumFractionDigits}`;
  let formatter = formatters.get(key);
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, {
      ...(style === 'currency' ? { style: 'currency', currency: 'USD' } : {}),
      ...(style === 'compact' ? { notation: 'compact', compactDisplay: 'short' } : {}),
      minimumFractionDigits,
      maximumFractionDigits,
    });
    if (formatters.size >= MAX_FORMATTERS) formatters.clear();
    formatters.set(key, formatter);
  }
  return formatter;
}
